/** @format */

import React, { useState, useEffect } from "react";
// import useSettings from "stores/settings";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
// Detail Menu
import AppDetailComments from "./appDetailMenu/appDetailComments";
// import AppDetailInquiry from "./appDetailMenu/inquiry";

import AppHeader from "./appDetailMenu/appHeader";
// import AppHashTag from "./appDetailMenu/appHashTag";
import AppContent from "./appDetailMenu/appContent";
import AppLicense from "./appDetailMenu/appLicense";

// import AppBodyImage from "./appDetailMenu/appBodyImage";
import AppBodyDataAnalysis from "./appDetailMenu/appBodyDataAnalysis";

import firebase from "firebase/app";
import SEO from "components/SEO";

import GetAppData from "components/GetAppData";

const AppDetailPage = observer(({ headUrl, headTitle, headDesc }) => {
  // const settings = useSettings();
  const router = useRouter();

  const [data, setData] = useState(null);

  /* 데이터 받아오기
   * 1. 앱 정보 받아오기
   * 2. 개발자 정보 받아오기
   */

  useEffect(async () => {
    const { id: appId } = router.query;
    if (appId) {
      const getData = await GetAppData(router.query.id);
      if (getData) {
        setData(getData);
      }
    }
  }, [router]);

  return (
    <div className="w-full">
      <SEO url={headUrl} title={headTitle} desc={headDesc} />
      {!data || data === null ? (
        <div className="flex justify-center items-center my-4"></div>
      ) : (
        <div className="page-content w-full pt-12 pb-36">
          <div className="aiso_detail_wrap">
            {/* 헤더 */}
            <AppHeader {...data} />
            {/* 해시태그 */}
            {/* <AppHashTag {...data} /> */}
            {/* 앱 실행 공간 */}
            {/* {data.inputType === "jpg" && <AppBodyImage {...data} />} */}
            <AppBodyDataAnalysis {...data} />

            {/* 앱 설명 */}
            <AppContent {...data} />
            {/* LICENSE 표시 */}
            <AppLicense {...data} />
            {/* 사용 후기 */}
            <AppDetailComments {...data} />
          </div>
        </div>
      )}
    </div>
  );
});

AppDetailPage.getInitialProps = async ({ asPath, query }) => {
  const { id } = query;

  let headTitle = "아이소";
  let headDesc = "인공지능 마켓, 아이소 입니다.";
  const headUrl = `https://aiso.ai${asPath}`;

  try {
    const publicDocRef = firebase.firestore().collection("market").doc("public").collection("app").doc(id);
    const privateDocRef = firebase.firestore().collection("market").doc("private").collection("app").doc(id);

    const publicValue = await publicDocRef.get();
    if (publicValue.exists) {
      headTitle = publicValue.data().appName;
      headDesc = publicValue.data().oneLineContent;
    } else {
      const privateValue = await privateDocRef.get();
      if (privateValue.exists) {
        headTitle = privateValue.data().appName;
        headDesc = privateValue.data().oneLineContent;
      }
    }
  } catch (error) {
    console.error(error);
  }

  return { headUrl, headTitle, headDesc };
};

export default AppDetailPage;
